// @ts-nocheck

const ERROR_CODE_ACCESS_DENIED = 1;
const ERROR_CODE_BAD_REQUEST_MISSING_PARAMS = 2;
const ERROR_CODE_INVALID_REFERENCE = 3;
const ERROR_CODE_MAINTENANCE = 4;
const ERROR_CODE_CANNOT_DISPLAY = 5;
const ERROR_CODE_VIDEO_UNAVAILABLE = 6;
const ERROR_CODE_BAD_REQUEST_INVALID_PARAMS = 7;
const ERROR_CODE_STREAM_GEOBLOCKED = 8;
const ERROR_CODE_DEFAULT = 999;

const ERROR_NOT_CONNECTED = 'NotConnected';
const ERROR_CANNOT_DISPLAY = 'CannotDisplay';
const ERROR_UNAVAILABLE = 'Unavailable';
const ERROR_GEO_BLOCKED = 'GeoBlocked';

const playerErrors = {
  ERROR_CODE_ACCESS_DENIED,
  ERROR_CODE_BAD_REQUEST_MISSING_PARAMS,
  ERROR_CODE_BAD_REQUEST_INVALID_PARAMS,
  ERROR_CODE_INVALID_REFERENCE,
  ERROR_CODE_MAINTENANCE,
  ERROR_CODE_CANNOT_DISPLAY,
  ERROR_CODE_VIDEO_UNAVAILABLE,
  ERROR_CODE_STREAM_GEOBLOCKED,
  ERROR_CODE_DEFAULT,
  ERROR_NOT_CONNECTED,
  ERROR_CANNOT_DISPLAY,
  ERROR_UNAVAILABLE,
  ERROR_GEO_BLOCKED,
};

export default playerErrors;
